module.exports = __webpack_public_path__ + "img/chrome.3ec66de6.svg";